module.exports = __webpack_public_path__ + "img/logo2.9eedbb0c.png";